export default __webpack_public_path__ + "static/blob-20-39dde990925fca57d687e1ef6a8d509a.svg";